import * as styles from "./TaggedTopics.module.scss";

import React from "react";
import { Tag } from "../common/Icons";

export interface TopicTag {
	title: string;
	url?: string;
}

export interface TaggedTopicsProps {
	tags: TopicTag[];
}
export const TaggedTopics: React.FC<TaggedTopicsProps> = ({ tags = [] }) => {
	return (
		<div className={styles.tagswrapper}>
			<div className={styles.icon}>
				<Tag height={"24px"} width={"24px"} />
			</div>
			<p className={styles.label}>Topics</p>
			{tags.map((tag) => (
				<span key={tag.title} className={styles.tagwrapper}>
					{tag.url ? (
						<a className={styles.tag} href={tag.url}>
							{tag.title}
						</a>
					) : (
						<p className={styles.tag}>{tag.title}</p>
					)}
				</span>
			))}
		</div>
	);
};

export default TaggedTopics;
